import { render, staticRenderFns } from "./HistoryLearningResultStudyContent.vue?vue&type=template&id=840f7d80&scoped=true&lang=pug&"
import script from "./HistoryLearningResultStudyContent.vue?vue&type=script&lang=ts&"
export * from "./HistoryLearningResultStudyContent.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryLearningResultStudyContent.vue?vue&type=style&index=0&id=840f7d80&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840f7d80",
  null
  
)

export default component.exports